export const translations = {

  pl: {
    /* ===== HERO ===== */
    heroTitle: "Transporty międzynarodowe",
    heroDesc: "Twój zaufany partner w logistyce",

    /* ===== NAVBAR ===== */
    services: "Usługi",
    about: "O nas",
    contact: "Kontakt",

    /* ===== SERVICES ===== */
    servicesTitle: "Usługi",
    servicesSubtitle: "Transport ponadgabarytowy, widenable, semitieflader, tiefbet, telesatel",

    servicesList: [
      {
        icon: "container",
        title: "TRANSPORT LCL, FCL",
        text: "Transport krajowy i międzynarodowy."
      },
      {
        icon: "insurance",
        title: "UBEZPIECZENIE CARGO",
        text: "Bezpieczeństwo przewozu."
      },
      {
        icon: "oversized",
        title: "PROJECT CARGO",
        text: "Ładunki wielkogabarytowe i nienormatywne."
      },
      {
        icon: "warehouse",
        title: "MAGAZYNOWANIE",
        text: "Przechowywanie towarów zależnie od potrzeb."
      },
      {
        icon: "crane",
        title: "OBSŁUGA DŹWIGOWA",
        text: "Rozładunek, przeładunek i kompletacja dostaw."
      },
      {
        icon: "multimodal",
        title: "TRANSPORT MULTIMODALNY",
        text: "Wysyłki kontenerowe."
      }
    ],

    /* ===== ABOUT ===== */
    aboutTitle: "Twój ładunek. Nasza odpowiedzialność.",
    aboutText: "Organizujemy transport w Polsce i Europie — od standardowych przesyłek po ładunki ponadgabarytowe. Dobieramy pojazdy, koordynujemy przewóz i dbamy o dokumentację.",

    aboutList: ["Transport dopasowany do ładunku", "Sprawdzeni partnerzy transportowi", "Obsługa dokumentów i formalności"],

    stats: {
      transports: "Wykonanych transportów",
      years: "Lat na rynku",
      clients: "Zadowolonych klientów"
    },

    /* ===== CONTACT ===== */
    coverage: {
      eyebrow: "Nasze kierunki",
      title: "Łączymy Twoją firmę z Europą",
      intro: "To kraje, do których jeździmy najczęściej. Organizujemy transport dopasowany do Twojego ładunku i potrzeb.",
      countries: { POL: "Polska", DEU: "Niemcy", SWE: "Szwecja", AUT: "Austria", DNK: "Dania", CHE: "Szwajcaria", CZE: "Czechy", NLD: "Holandia", HUN: "Węgry", ITA: "Włochy", SVK: "Słowacja", FRA: "Francja", ESP: "Hiszpania", HRV: "Chorwacja", SVN: "Słowenia", FIN: "Finlandia", LTU: "Litwa", LVA: "Łotwa", EST: "Estonia" },
      invitationTitle: "Twój kierunek jest gdzie indziej?",
      invitation: "To nasze główne kierunki, ale chętnie podejmiemy się również innych wyzwań transportowych. Planujesz transport do innego kraju? Porozmawiajmy o możliwościach.",
      cta: "Zapytaj o transport",
      mapTitle: "Główne kierunki transportu w Europie",
      legend: "Główne kierunki transportu",
      source: "Dane mapy: Natural Earth"
    },
    contactTitle: "Kontakt",
    contactDetails: {
      title: "Porozmawiajmy o Twoim transporcie.",
      description: "Masz ładunek do przewiezienia lub pytanie o współpracę? Zadzwoń lub napisz — wspólnie znajdziemy odpowiednie rozwiązanie.",
      call: "Zadzwoń",
      write: "Napisz",
      hoursTitle: "Jesteśmy do Twojej dyspozycji",
      days: "Poniedziałek–piątek"
    },
    phone: "Telefon",
    email: "Email",
    address: "Adres"
  },



  en: {
    /* ===== HERO ===== */
    heroTitle: "International delivery",
    heroDesc: "Your trusted partner in logistics",

    /* ===== NAVBAR ===== */
    services: "Services",
    about: "About us",
    contact: "Contact",

    /* ===== SERVICES ===== */
    servicesTitle: "Our Services",
    servicesSubtitle: "Oversize transport, widenable, semitieflader, tiefbet, telesatel",

    servicesList: [
      {
        icon: "container",
        title: "LCL & FCL TRANSPORT",
        text: "Domestic and international transport."
      },
      {
        icon: "insurance",
        title: "CARGO INSURANCE",
        text: "Safe and secure shipment."
      },
      {
        icon: "oversized",
        title: "PROJECT CARGO",
        text: "Oversized and heavy cargo transport."
      },
      {
        icon: "warehouse",
        title: "WAREHOUSING",
        text: "Storage depending on your needs."
      },
      {
        icon: "crane",
        title: "CRANE SERVICES",
        text: "Loading, unloading and handling."
      },
      {
        icon: "multimodal",
        title: "MULTIMODAL TRANSPORT",
        text: "Container shipments."
      }
    ],

    /* ===== ABOUT ===== */
    aboutTitle: "Your cargo. Our responsibility.",
    aboutText: "We arrange transport across Poland and Europe, from standard shipments to oversized cargo. We select suitable vehicles, coordinate delivery and take care of documentation.",

    aboutList: ["Transport tailored to your cargo", "Verified transport partners", "Documentation and customs support"],

    stats: {
      transports: "Completed transports",
      years: "Years on the market",
      clients: "Satisfied clients"
    },

    /* ===== CONTACT ===== */
    coverage: {
      eyebrow: "Our destinations",
      title: "Connecting your business with Europe",
      intro: "These are the countries we serve most often. We arrange transport tailored to your cargo and your needs.",
      countries: { POL: "Poland", DEU: "Germany", SWE: "Sweden", AUT: "Austria", DNK: "Denmark", CHE: "Switzerland", CZE: "Czechia", NLD: "Netherlands", HUN: "Hungary", ITA: "Italy", SVK: "Slovakia", FRA: "France", ESP: "Spain", HRV: "Croatia", SVN: "Slovenia", FIN: "Finland", LTU: "Lithuania", LVA: "Latvia", EST: "Estonia" },
      invitationTitle: "Looking for a different destination?",
      invitation: "These are our main destinations, but we are happy to take on other transport challenges too. Planning a shipment to another country? Let’s discuss the possibilities.",
      cta: "Ask about transport",
      mapTitle: "Main transport destinations in Europe",
      legend: "Main transport destinations",
      source: "Map data: Natural Earth"
    },
    contactTitle: "Contact",
    contactDetails: {
      title: "Let’s talk about your transport.",
      description: "Have a shipment to arrange or a question about working together? Call or email us — we’ll find the right solution together.",
      call: "Call us",
      write: "Email us",
      hoursTitle: "Our office hours",
      days: "Monday–Friday"
    },
    phone: "Phone",
    email: "Email",
    address: "Address"
  }

};
